const IN_LEFT = -1;
const IN_RIGHT = 1;

export { IN_LEFT, IN_RIGHT };
